import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import InstallBanner from "../components/InstallBanner";
import "../montacargas.css";

function MontacargasLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleForceLogout = () => navigate("/montacargas", { replace: true });
    window.addEventListener("montacargas-force-logout", handleForceLogout);
    return () => window.removeEventListener("montacargas-force-logout", handleForceLogout);
  }, [navigate]);

  return (
    <div className="montacargas-app">
      <header className="container py-3">
        <h1 className="h5 mb-2">Montacargas</h1>
        <InstallBanner />
      </header>
      <main className="container pb-4">
        <Outlet />
      </main>
    </div>
  );
}

export default MontacargasLayout;
